// Import centralized chart config first to ensure all Chart.js components are registered
import '../config/chartConfig';

import MainDashboard from "../pages/Dashboard/MainDashboard";
import PeoplePlan from "../components/PeoplePlan/PeoplePlan";
import HRDashboard from "../pages/HR/HRDashboard";
import CRMTickets from "../pages/HR/CRM/CRMTickets";
import ToDoTickets from "../pages/HR/CRM/ToDoTickets";
import TADashboard from "../pages/TA/TADashboard";
import TACRMTickets from "../pages/TA/TACRMTickets";
import Jobs from "../pages/TA/Jobs";
import CandidateTracker from "../pages/TA/CandidateTracker";
import NewHires from "../pages/TA/NewHires";
import TAToDoTickets from "../pages/TA/TAToDoTickets";
import LDDashboard from "../pages/LD/LDDashboard";
import WeeklyCheckins from "../pages/LD/WeeklyCheckins";
import DepositoryFiles from "../pages/LD/DepositoryFiles";
import WindowReadinessResults from "../pages/LD/WindowReadinessResults/WindowReadinessResults";
import GoalsOKRs from "../pages/LD/PeoplePulse/Goals/GoalsOKRs";
import OneOnOneMeetings from "../pages/LD/PeoplePulse/OneOnOne/OneOnOneMeetings";
import PerformanceReviews from "../pages/LD/PeoplePulse/Reviews/PerformanceReviews";
import FeedbackRecognition from "../pages/LD/PeoplePulse/Feedback/FeedbackRecognition";
import TasksActionItems from "../pages/LD/PeoplePulse/Tasks/TasksActionItems";
import Settings from "../pages/Settings/Settings";
import { ExecutiveDashboard, PipelineDashboard, HiresDashboard } from "../pages/recruiting";

export const ROLES = {
  ADMIN: "admin",
  DIRECTOR: "director",
  VP: "vp",
  MUM: "mum",
  HR: "hr",
  TA: "ta",
  LD: "ld",
  LD_DIRECTOR: "ld_director",
};

export const pages = [
  {
    name: "Dashboard",
    path: "/dashboard",
    element: <MainDashboard />,
    allowed: Object.values(ROLES),
  },
  {
    name: "People Plan",
    path: "/peopleplan",
    element: <PeoplePlan />,
    allowed: Object.values(ROLES),
  },

  /* ---------------- HR ---------------- */
  {
    name: "hr",
    allowed: [ROLES.ADMIN, ROLES.HR],
    children: [
      { name: "HR Dashboard", path: "/hr", element: <HRDashboard />, allowed: [ROLES.ADMIN, ROLES.HR] },
      { name: "HR Requests", path: "/hr/crm/tickets", element: <CRMTickets />, allowed: Object.values(ROLES) },
      { name: "To Do Tickets", path: "/hr/crm/todo-tickets", element: <ToDoTickets />, allowed: [ROLES.ADMIN, ROLES.HR] },
    ]
  },

  /* ---------------- TA ---------------- */
  {
    name: "ta",
    allowed: [ROLES.ADMIN, ROLES.TA],
    children: [
      { name: "TA Dashboard", path: "/ta", element: <TADashboard />, allowed: [ROLES.ADMIN, ROLES.TA] },
      { name: "Executive Dashboard", path: "/recruiting/executive", element: <ExecutiveDashboard />, allowed: [ROLES.ADMIN, ROLES.TA] },
      { name: "Pipeline Dashboard", path: "/recruiting/pipeline", element: <PipelineDashboard />, allowed: [ROLES.ADMIN, ROLES.TA] },
      { name: "Hires Dashboard", path: "/recruiting/hires", element: <HiresDashboard />, allowed: [ROLES.ADMIN, ROLES.TA] },
      { name: "TA Requests", path: "/ta/crm/tickets", element: <TACRMTickets />, allowed: Object.values(ROLES) },
      { name: "To Do Tickets", path: "/ta/requests", element: <TAToDoTickets />, allowed: [ROLES.ADMIN, ROLES.TA] },
      { name: "Job Tracker", path: "/ta/jobs", element: <Jobs />, allowed: [ROLES.ADMIN, ROLES.TA] },
      { name: "Candidate Tracker", path: "/ta/candidates", element: <CandidateTracker />, allowed: [ROLES.ADMIN, ROLES.TA] },
      { name: "Onboarding", path: "/ta/newhires", element: <NewHires />, allowed: [ROLES.ADMIN, ROLES.TA] },
    ]
  },

  /* ---------------- L&D ---------------- */
  {
    name: "ld",
    allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR],
    children: [
      { name: "L&D Dashboard", path: "/ld", element: <LDDashboard />, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
      { name: "Weekly Checkins", path: "/ld/checkins", element: <WeeklyCheckins />, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
      { name: "Depository Files", path: "/ld/files", element: <DepositoryFiles />, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
      { name: "Window Readiness Results", path: "/ld/window-readiness", element: <WindowReadinessResults />, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
      { name: "Goals & OKRs", path: "/peoplepulse/goals", element: <GoalsOKRs />, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
      { name: "1-on-1 Meetings", path: "/peoplepulse/one-on-one", element: <OneOnOneMeetings />, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
      { name: "Performance Reviews", path: "/peoplepulse/reviews", element: <PerformanceReviews />, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
      { name: "Feedback & Recognition", path: "/peoplepulse/feedback", element: <FeedbackRecognition />, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
      { name: "Tasks & Action Items", path: "/peoplepulse/tasks", element: <TasksActionItems />, allowed: [ROLES.ADMIN, ROLES.LD, ROLES.LD_DIRECTOR] },
    ]
  },

  /* ---------------- Settings ---------------- */
  {
    name: "Settings",
    path: "/settings",
    element: <Settings />,
    allowed: [ROLES.ADMIN, ROLES.HR, ROLES.TA, ROLES.LD, ROLES.LD_DIRECTOR],
  },
  {
    name: 'IT',
    type: 'external',
    url: 'http://support.cafuamanagement.com/helpdesk/WebObjects/Helpdesk.woa',
    allowed: Object.values(ROLES),
    target: '_blank',
  },
];



